export class ListGcpOrganizationsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "organizations",
            "baseName": "organizations",
            "type": "Array<GcpOrganization>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGcpOrganizationsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
